import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {UnsubscribeOnDestroyAdapter} from "@shared";
import {BehaviorSubject} from "rxjs";
import {DefaultResponse} from "@core/models/Http/DefaultResponse";
import {environment} from "@enviroment/environment";
import {Township} from "@core/models/Township";
import {HttpMesageHandlerService} from "@core/service/http-mesage-handler";

@Injectable({
  providedIn: 'root'
})
export class TownshipService extends UnsubscribeOnDestroyAdapter {
  isTblLoading = true;
  dataChange: BehaviorSubject<Township[]> = new BehaviorSubject<Township[]>([]);

  constructor(
    private httpClient: HttpClient,
    private httpMsgHandler: HttpMesageHandlerService
  ) {
    super();
  }

  get data(): Township[] {
    return this.dataChange.value;
  }

  getTownshipByIdEntidad(idEntidad: number, nombreEntidad: string): void {
    if (idEntidad && idEntidad > 0) {
      const idEntidadStr = idEntidad.toString();
      this.subs.sink = this.httpClient.get<DefaultResponse<Township[]>>(
        `${environment.backend_url}CatMunicipios/municipiosbyEntidad/${idEntidadStr}`,
      ).subscribe({
        next: (data) => {
          data.data.forEach((town: Township) => {
            town.nombreEntidad = nombreEntidad;
          })
          this.isTblLoading = false;
          this.dataChange.next(data.data);
        },
        error: (error: HttpErrorResponse) => {
          this.isTblLoading = false;
          this.httpMsgHandler.handleMsg(error);
        },
      });
    } else {
      this.isTblLoading = false;
      this.dataChange.next([]);
    }
  }
}
